// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"e2-z"};